import { ElementType, lazy, Suspense } from 'react';

// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const Page403 = Loadable(lazy(() => import('../screens/common/Page403')));
export const Page404 = Loadable(lazy(() => import('../screens/common/Page404')));
export const Page500 = Loadable(lazy(() => import('../screens/common/Page500')));
export const ComingSoon = Loadable(lazy(() => import('../screens/common/ComingSoon')));
export const Maintenance = Loadable(lazy(() => import('../screens/common/Maintenance')));
export const Login = Loadable(lazy(() => import('../screens/auth/login/Login')));
export const ResetPassword = Loadable(
  lazy(() => import('../screens/auth/reset-password/ResetPassword')),
);

// Management
export const Popup = Loadable(lazy(() => import('../screens/management/popup/Popup')));
export const Recruit = Loadable(lazy(() => import('../screens/management/recruit/Recruit')));
export const Category = Loadable(
  lazy(() => import('../screens/management/contents/category/Category')),
);
export const IRStatistics = Loadable(lazy(() => import('../screens/management/ir/Ir')));
export const PRManagement = Loadable(lazy(() => import('../screens/management/pr/Pr')));

// Admin Management
export const MenuManagement = Loadable(lazy(() => import('../screens/admin-management/menu/Menu')));
export const GroupManagement = Loadable(
  lazy(() => import('../screens/admin-management/group/Group')),
);
export const EmployeeManagement = Loadable(
  lazy(() => import('../screens/admin-management/employee/Employee')),
);

// Guide
export const Guide = Loadable(lazy(() => import('../screens/guide/Guide')));
